import fetch from '../../fetch';

import utils from '../../../utils';


const prefixUrL = 'survey/common/analysis/'

const columns = utils.columns([
    {
        key: '$index', 
        label: '序号'
    },
    {
        key: 'targetName',
        label: '指标名称'
    },
    {
        key: 'itemName',
        label: '依据名称'
    },
    {
        key: 'time',
        label: '次数'
    },
    {
        key: 'score',
        label: '分数'
    }
]);


/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if(keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)

    const targetId = keywords.targetId;
    let retResponse;
    if (targetId) {
        retResponse = fetch.post(`${prefixUrL}target/analysis?` + params.join('&'), keywords)
    } else {
        retResponse = buildEmptyPromise(keywords.pageNum, keywords.pageSize);
    }

    return retResponse
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

const buildEmptyPromise = (pageNum, pageSize) => {
    return new Promise((resolve, reject) => {
        resolve({
            code: 200,
            payload: {
                data: {
                    dataList: [],
                    pageNum,
                    pageSize,
                    total: 0
                }
            }
        })
    })
}

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids;
}

/**
 * @method getSelection
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const getSelection = () => {
    return DataGrid.selections;
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback;
};

/**
 * @method redirect
 * @param {string} url
 * @return {void}
 */
const redirect = (url) => {
    
};


export default {
    querySearch,
    columns,
    onSelect,
    setRefresh,
    getSelection,
    redirect,
}